module.exports = __webpack_public_path__ + "img/fig28.bd14ea1a.jpg";